<template>
 <div
  style="
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
  "
>
  <!-- Left: Title -->
  <div style="display: flex; align-items: center; gap: 8px; flex: 1 1 auto; min-width: 220px;">
    <h1
      style="
        font-size: 1.125rem;
        font-weight: 600;
        color: #1f2937;
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 0;
      "
    >
      <i class="ri-global-line" style="color: #2563eb; font-size: 1.25rem;"></i>
      {{ selectedWebsiteName || "Select your website" }}
    </h1>
  </div>

  <!-- Right: Website & Filter -->
  <div
    style="
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
      justify-content: flex-end;
      flex: 1 1 auto;
      min-width: 260px;
    "
  >
    <select
      v-model="selectedWebsite"
      @change="handleWebsiteChange"
      style="
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        font-size: 0.875rem;
        padding: 6px 12px;
        color: #4b5563;
        transition: border-color 0.2s ease;
        flex: 1 1 140px;
      "
    >
      <option disabled value="">-- Select Website --</option>
      <option v-for="site in websites" :key="site.web_id" :value="site.web_id">
        {{ site.web_link }}
      </option>
    </select>

    <select
      v-model="filterVal"
      @change="handleFilterChange"
      style="
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        font-size: 0.875rem;
        padding: 6px 12px;
        color: #4b5563;
        transition: border-color 0.2s ease;
        flex: 1 1 140px;
      "
    >
      <option value="today">Today</option>
      <option value="last_7_days">Last 7 Days</option>
      <option value="last_month">Last 30 Days</option>
      <option value="last_12_months">Last 12 Months</option>
      <option value="custom">Custom Range</option>
    </select>

    <input
      v-if="filterVal === 'custom'"
      type="date"
      v-model="dateFrom"
      style="
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        font-size: 0.875rem;
        padding: 6px 12px;
        color: #4b5563;
        flex: 1 1 140px;
      "
    />

    <input
      v-if="filterVal === 'custom'"
      type="date"
      v-model="dateTo"
      style="
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        font-size: 0.875rem;
        padding: 6px 12px;
        color: #4b5563;
        flex: 1 1 140px;
      "
    />

    <button
      @click="fetchDashboard"
      style="
        padding: 8px 16px;
        background-color: #2563eb;
        color: #fff;
        border: none;
        border-radius: 8px;
        font-size: 0.875rem;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.2s ease;
        flex: 1 1 100px;
      "
      onmouseover="this.style.backgroundColor='#1d4ed8'"
      onmouseout="this.style.backgroundColor='#2563eb'"
    >
      Search
    </button>
  </div>
</div>


  <!-- KPIs -->
  <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 mt-4">
    <div
      v-for="(kpi, i) in kpis"
      :key="i"
      class="card text-center p-3 border border-gray-100 rounded-xl shadow-sm bg-white"
    >
      <p class="text-xs text-gray-500 mb-1">{{ kpi.label }}</p>
      <h3 class="text-2xl font-bold text-gray-800">{{ kpi.value ?? placeholderValue }}</h3>
    </div>
  </div>

  <!-- Branding Banner -->
  <div class="row grid grid-cols-1 mt-6">
    <div
      class="card bg-gradient-to-r from-indigo-600 via-blue-600 to-cyan-500 text-white flex flex-col md:flex-row justify-between items-center shadow-lg"
    >
      <div class="max-w-md">
        <h3 class="text-2xl font-semibold mb-2">
          Talk to Your <span class="font-bold">Data with AI</span>
        </h3>
        <p class="text-sm opacity-90 mb-4">
          Now you can ask our AI what needs to be done next and finally understand what all those numbers are really saying.
        </p>
        <div class="flex gap-3 flex-wrap">
          <button
          @click="gotoPLans()"
            class="px-4 py-2 bg-white text-blue-700 rounded-lg font-medium hover:bg-gray-100 transition"
          >
            Explore Plans
          </button>
          <!-- <button
            class="px-4 py-2 border border-white/70 text-white rounded-lg font-medium hover:bg-white hover:text-blue-700 transition"
          >
            Learn More
          </button> -->
        </div>
      </div>
      <img src="/images/home1.png" alt="Brand Identity" style="width: 26rem; height: auto;"
        class="rounded-lg mt-6 md:mt-0 md:ml-6" />
    </div>
  </div>

  <!-- Charts Section -->
  <div class="row grid lg:grid-cols-3 gap-6 mt-6">
    <!-- Left Column -->
    <div class="col-span-2 space-y-6">
      <div class="card" style="width:100%; max-width:100%; overflow:hidden; box-sizing:border-box;">
        <h3 class="text-lg font-semibold mb-2">Your Website Progress</h3>
        <p class="text-sm text-gray-500 mb-3">Track, measure, and visualize your website growth effectively.</p>
        <div v-if="!loading && chartData.visitors.length" id="progressChart" class="h-64"></div>
        <div v-else class="h-64 flex items-center justify-center text-gray-400">
          <i class="ri-line-chart-line text-2xl mr-2"></i> No data available
        </div>
      </div>

      <div class="card" style="width:100%; max-width:100%; overflow:hidden; box-sizing:border-box;">
        <h3 class="text-lg font-semibold mb-2">Sources Report</h3>
        <p class="text-sm text-gray-500 mb-3">Detailed insights about where your visitors come from.</p>
        <div v-if="!loading && chartData.sources.length" id="sourcesChart" class="h-64"></div>
        <div v-else class="h-64 flex items-center justify-center text-gray-400">
          <i class="ri-donut-chart-fill text-2xl mr-2"></i> No source data
        </div>
      </div>

      <div class="card">
        <h3 class="text-lg font-semibold mb-3">Users By Country</h3>
        <div v-if="!loading && chartData.countries.length" id="mapdiv" class="w-full h-96 rounded-lg"></div>
        <div v-else class="h-96 flex items-center justify-center text-gray-400">
          <i class="ri-earth-line text-2xl mr-2"></i> No geographic data
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="space-y-6">
      <div class="card bg-blue-700 text-white">
        <h4 class="text-sm opacity-80 mb-1">Realtime Visitors</h4>
        <p class="text-4xl font-bold mb-2">{{ totalVisitors }}</p>
        <!-- <p class="text-sm">Realtime Visitors: <span class="font-semibold">{{ realtimeVisitors }}</span></p> -->
      </div>

      <div class="card">
        <h3 class="text-lg font-semibold mb-3">Top Referrers</h3>
        <ul v-if="chartData.sources.length" class="space-y-3 text-sm">
          <li v-for="(ref, i) in chartData.sources" :key="i" class="flex justify-between items-center border-b border-gray-100 pb-2">
            <div class="flex items-center gap-2"><i class="ri-links-line text-blue-600 text-lg"></i> {{ ref.source }}</div>
            <span class="font-semibold text-gray-900">{{ ref.visitors }}</span>
          </li>
        </ul>
        <div v-else class="text-gray-400 text-center py-6">No referrer data available</div>
      </div>

      <div class="card" style="width:100%; max-width:100%; overflow:hidden; box-sizing:border-box;">
        <h3 class="text-lg font-semibold mb-3">Users by Device</h3>
        <div v-if="!loading && chartData.devices.length" id="deviceChart" class="h-64"></div>
        <div v-else class="h-64 flex items-center justify-center text-gray-400">
          <i class="ri-macbook-line text-2xl mr-2"></i> No device data available
        </div>

        <div v-if="chartData.devices.length" class="grid grid-cols-2 text-sm mt-6 gap-y-2">
          <div v-for="(d, i) in chartData.devices" :key="i">
            <p class="font-medium text-blue-600">{{ d.browser }}</p>
            <p class="text-gray-600">{{ d.visitors }}</p>
          </div>
        </div>
      </div>

      <div class="card" style="width:100%; max-width:100%; overflow:hidden; box-sizing:border-box;">
        <h3 class="text-lg font-semibold mb-3">Conversion Funnel</h3>
        <div v-if="!loading && chartData.funnel.length" id="funnelChart" class="h-96"></div>
        <div v-else class="h-96 flex items-center justify-center text-gray-400">
          <i class="ri-bar-chart-horizontal-line text-2xl mr-2"></i> No funnel data available
        </div>
      </div>
    </div>
  </div>
<div
  v-if="loading"
  class="fixed inset-0 bg-white/80 backdrop-blur-sm flex flex-col items-center justify-center z-[999]"
  style="margin-top: 0rem;"
>
  <div class="loader border-4 border-blue-500 border-t-transparent rounded-full w-12 h-12 animate-spin mb-4"></div>
  <p class="text-gray-700 text-sm font-medium">Fetching analytics data...</p>
</div>
  <!-- <ChatWidget v-if="selectedWebsite && ldata" :userId="ldata.user_id" :webId="selectedWebsite" :report_dt="report_dt" /> -->
</template>

<script>
import ApexCharts from "apexcharts";
import * as am5 from "@amcharts/amcharts5";
import * as am5map from "@amcharts/amcharts5/map";
import am5geodata_worldLow from "@amcharts/amcharts5-geodata/worldLow";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
// import ChatWidget from "@/comps/ChatWidget.vue";
import { getDashboardReport, getWebsiteList } from "@/apis/dashapis";

export default {
  name: "HomePage",
  // components: { ChatWidget },
  data() {
    return {
      ldata: null,
      report_dt: null,
      websites: [],
      selectedWebsite: "",
      selectedWebsiteName: "",
      filterVal: "last_month",
      dateFrom: "",
      dateTo: "",
      kpis: [],
      chartData: { visitors: [], sources: [], devices: [], countries: [], funnel: [] },
      totalVisitors: 0,
      realtimeVisitors: 0,
      referrers: [],
      loading: true,
      placeholderValue: "--",
    };
  },
  async mounted() {
     if ((window.location.href + "").includes("web_id")) {
      this.selectedWebsite = this.$route.query.web_id;
      this.selectedWebsiteName = this.$route.query.web_name;
      this.fetchDashboard();
    }
    if (sessionStorage.getItem("ldata")) {
      this.ldata = JSON.parse(sessionStorage.getItem("ldata"));
      await this.loadWebsites();
    }
  },
  methods: {
    gotoPLans(){
      window.location.href = "/pricing";
    },
    handleWebsiteChange() {
    const selected = this.websites.find(
      (w) => w.web_id === this.selectedWebsite
    );

    if (selected) {
      this.selectedWebsiteName = selected.web_link;

      this.fetchDashboard();
    }
  },
    async loadWebsites() {
      try {
        const res = await getWebsiteList(this.ldata.user_id);
        if (res.status && res.records?.length) {
          this.websites = res.records;
          if(this.selectedWebsite.length<=0){
            this.selectedWebsite = res.records[0].web_id;
            this.selectedWebsiteName = res.records[0].web_link;
            this.fetchDashboard();
          }
        } else this.loading = false;
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },

    handleFilterChange() {
      if (this.filterVal !== "custom") {
        this.dateFrom = "";
        this.dateTo = "";
      }
    },

    async fetchDashboard() {
      if (!this.selectedWebsite) return;
      this.loading = true;
      try {
        const res = await getDashboardReport(
          this.selectedWebsite,
          this.filterVal,
          this.dateFrom,
          this.dateTo
        );
        if (res.status && res.report_dt) {
          const data = res.report_dt;
          this.report_dt = data;

          // KPIs
          this.kpis = [
            { label: "Unique Visitors", value: data.overview.unique_visitors || 0 },
            { label: "Total Visits", value: data.overview.total_visits || 0 },
            { label: "Total Pageviews", value: data.overview.total_pageviews || 0 },
            { label: "Views Per Visit", value: data.overview.views_per_visit || 0 },
            { label: "Bounce Rate", value: (data.overview.bounce_rate || 0) + "%" },
            { label: "Visit Duration", value: data.overview.visit_duration || "0s" },
          ];

          this.chartData = {
            visitors: data.timeseries_events || [],
            sources: data.sources || [],
            devices: data.devices || [],
            countries: data.countries || [],
            funnel: data.sources1 || [],
          };

          // Referrers (Top Sources)
          this.referrers = this.chartData.sources.map((s) => ({
            name: s.source || "Unknown",
            percent: s.visitors || 0,
            icon: "ri-external-link-line",
          }));

          this.totalVisitors = data.overview.total_visits || 0;
          this.realtimeVisitors = Math.floor(this.totalVisitors / 10) || 0;

          this.$nextTick(() => {
            this.renderCharts();
            this.renderMap();
          });
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    // === CHARTS ===
    renderCharts() {
      // Clean old charts if exist
      document.querySelectorAll(".apexcharts-canvas").forEach((el) => el.remove());

      // Monthly aggregation for line chart
      const today = new Date();
      const tenDaysAgo = new Date();
      tenDaysAgo.setDate(today.getDate() - 9);

      const dailyData = [];
      for (let i = 0; i < 10; i++) {
        const d = new Date(tenDaysAgo);
        d.setDate(tenDaysAgo.getDate() + i);
        //const dateStr = d.toISOString().slice(0, 10);
        const dateStr = d.toISOString().slice(0, 10);
        const found = this.chartData.visitors.find(v => v.date === dateStr);
        dailyData.push({
          date: dateStr,
          visitors: found ? found.visitors : 0,
        });
      }

      this.chartData.last10Days = dailyData;


      const months = this.chartData.last10Days.map(d => {
      const date = new Date(d.date);
      return date.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "short"
      }).replace(",", "");
    });

      const monthVisitors = this.chartData.last10Days.map(d => d.visitors);


      new ApexCharts(document.querySelector("#progressChart"), {
        chart: { type: "line", height: 250, toolbar: { show: false } },
        series: [{ name: "Visitors", data: monthVisitors.length ? monthVisitors : [0] }],
        xaxis: { categories: months.length ? months : ["Jan"] },
        stroke: { curve: "smooth", width: 3 },
        colors: ["#2563eb"], // 🔵 Blue
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            gradientToColors: ["#3b82f6"], // lighter blue for gradient
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 90, 100],
          },
        },
        grid: { borderColor: "#f3f4f6" },
      }).render();


      // Sources Report (Area Chart)
      const sources = this.chartData.sources?.map((s) => s.source) || [];
      const visitors = this.chartData.sources?.map((s) => s.visitors) || [];

      new ApexCharts(document.querySelector("#sourcesChart"), {
        chart: { type: "area", height: 250, toolbar: { show: false } },
        series: [{
          name: "Sources",
          data: visitors.length > 0 ? visitors : [0, 0, 0],
        }],
        xaxis: {
          categories: sources.length > 0 ? sources : ["No Data", "No Data", "No Data"],
        },
        colors: ["#10b981"],
        stroke: { curve: "smooth", width: 3 },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 0.8,
            opacityFrom: 0.9,
            opacityTo: 0.5,
            stops: [0, 90, 100],
          },
        },
        grid: { borderColor: "#e5e7eb" },
      }).render();


      // Users by Device (Donut Chart)
      const deviceLabels = this.chartData.devices.map((d) => d.browser);
      const deviceData = this.chartData.devices.map((d) => d.visitors);
      new ApexCharts(document.querySelector("#deviceChart"), {
        chart: { type: "donut", height: 250 },
        labels: deviceLabels.length ? deviceLabels : ["Desktop", "Mobile", "Tablet", "Other"],
        series: deviceData.length ? deviceData : [45, 35, 12, 8],
        colors: ["#2563eb", "#22c55e", "#facc15", "#a855f7"],
        legend: { position: "bottom" },
        dataLabels: { enabled: false },
        stroke: { width: 0 },
      }).render();

      // Conversion Funnel (Horizontal Bar)
      const MAX_LABEL_LENGTH = 40;

const funnelData = this.chartData.funnel.map((f) => {
  let label = f.page || "Unknown";

  // 🔹 Limit text length
  if (label.length > MAX_LABEL_LENGTH) {
    label = label.substring(0, MAX_LABEL_LENGTH) + "...";
  }

  return {
    x: label,
    y: f.visitors || 0,
  };
});
      new ApexCharts(document.querySelector("#funnelChart"), {
        chart: { type: "bar", height: 380, toolbar: { show: false } },
        plotOptions: {
          bar: { horizontal: true, borderRadius: 6, barHeight: "70%" },
        },
        series: [{ data: funnelData.length ? funnelData : [{ x: "Visitors", y: 0 }] }],
        colors: ["#2563eb"],
        dataLabels: { enabled: true },
        grid: { borderColor: "#f3f4f6" },
        tooltip: { theme: "light" },
      }).render();
    },

    // === WORLD MAP ===
   renderMap() {
  const countriesData = this.chartData.countries;
  if (!countriesData.length) return;

  am5.ready(() => {
    const root = am5.Root.new("mapdiv");
    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5map.MapChart.new(root, { projection: am5map.geoMercator() })
    );

    const polygonSeries = chart.series.push(
      am5map.MapPolygonSeries.new(root, {
        geoJSON: am5geodata_worldLow,
      })
    );

    // 🔹 Build lookup map from API
    const countryVisitors = {};
    countriesData.forEach((c) => {
      countryVisitors[c.country] = Number(c.visitors) || 0;
    });

    // 🔹 Compute color range (for gradient coloring)
    const maxVisitors = Math.max(...Object.values(countryVisitors));
    const minColor = am5.color(0xdbeafe); // light blue
    const maxColor = am5.color(0x2563eb); // dark blue

    polygonSeries.mapPolygons.template.setAll({
      tooltipText: "{name}: {value}",
      interactive: true,
    });

    // 🔹 Assign visitor data
    polygonSeries.data.setAll(
      Object.keys(countryVisitors).map((country) => ({
        id: "IN" === country ? "IN" : country,
        name: country,
        value: countryVisitors[country],
      }))
    );

    // 🔹 Adaptive fill: highlight countries based on visitors
    polygonSeries.mapPolygons.template.adapters.add("fill", (fill, target) => {
      const countryId = target.dataItem?.dataContext?.id;
      const value = countryVisitors[countryId];
      if (value) {
        const ratio = value / maxVisitors;
        return am5.Color.interpolate(minColor, maxColor, ratio);
      }
      return am5.color(0xdbeafe);
    });

    polygonSeries.mapPolygons.template.states.create("hover", {
      fill: am5.color(0x1d4ed8), // blue hover
    });
  });
}
  },
  watch: {
  loading(newVal) {
    if (newVal) document.body.classList.add("loading");
    else document.body.classList.remove("loading");
  },
},
};
</script>



<style>
/* === Global Container Guards === */
html,
body {
  overflow-x: hidden !important;
  max-width: 100%;
}

/* === General Chart Fixes (Prevent Overflow) === */
#funnelChart {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden; /* funnel can scroll horizontally on smaller screens */
  display: block;
}

#deviceChart {
  width: 100%;
  max-width: 100%;
  height: 260px !important;
  overflow: hidden !important; /* prevent scrollbars */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Center ApexCharts canvases properly */
#deviceChart .apexcharts-canvas {
  margin: 0 auto !important;
  overflow: hidden !important;
}

/* Make chart areas scrollable only in mobile view (for funnel) */
@media (max-width: 768px) {
  #funnelChart {
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 1rem;
  }

  /* Donut chart still stays fixed */
  #deviceChart {
    overflow: hidden !important;
    padding-bottom: 0;
  }

  /* Prevent chart cards from causing horizontal scroll */
  .card {
    overflow-x: hidden;
  }
}


/* Optional: Keep donut chart centered */
#deviceChart .apexcharts-canvas {
  margin: 0 auto !important;
}
/* === Welcome Popup Animations === */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeIn {
  animation: fadeIn 0.6s ease forwards;
}

/* ✨ Sparkle animation */
@keyframes sparkle {
  0%, 100% {
    transform: scale(0.8);
    opacity: 0.4;
  }
  50% {
    transform: scale(1.6);
    opacity: 1;
  }
}
.animate-sparkle {
  animation: sparkle 2s infinite ease-in-out;
  position: absolute;
}

/* === Loader Spinner === */
.loader {
  border-radius: 50%;
  border-style: solid;
  border-width: 4px;
  border-color: #2563eb transparent #2563eb transparent;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Loader overlay ensures no scrolling while loading */
body.loading {
  overflow: hidden !important;
}


</style>
